import { ClubManagementData } from '../../hooks/useClubManagementData'
import { ClubListPanel } from './ClubListPanel'

interface ClubGridWithToolsProps {
  filteredAndSortedClubs: ClubManagementData[]
  totalClubs: number
  selectedClubId: number | null
  onSelectClub: (clubId: number) => void
  searchTerm: string
  onSearchChange: (term: string) => void
  sortValue: string
  onSortChange: (value: string) => void
  onShowBulkUpload: (show: boolean) => void
}

export const ClubGridWithTools = ({
  filteredAndSortedClubs,
  totalClubs,
  selectedClubId,
  onSelectClub,
  searchTerm,
  onSearchChange,
  sortValue,
  onSortChange,
  onShowBulkUpload,
}: ClubGridWithToolsProps) => (
  <div className="bg-white p-4">
    {/* Header with tools */}
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-sm font-semibold text-gray-900">
        Clubs
        <span className="text-gray-400 font-normal ml-1.5">({filteredAndSortedClubs.length})</span>
      </h2>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onShowBulkUpload(true)}
          className="flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-gray-700 border border-gray-200 hover:bg-gray-50 transition-colors"
        >
          <svg className="w-3.5 h-3.5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          Bulk Upload
        </button>
      </div>
    </div>

    <ClubListPanel
      clubs={filteredAndSortedClubs}
      selectedClubId={selectedClubId}
      onSelectClub={onSelectClub}
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      sortValue={sortValue}
      onSortChange={onSortChange}
      emptySearchTerm={searchTerm || undefined}
    />

    {totalClubs > filteredAndSortedClubs.length && !searchTerm && (
      <div className="text-center py-2 text-xs text-gray-500">
        Showing {filteredAndSortedClubs.length} of {totalClubs} clubs
      </div>
    )}
  </div>
)
